import React, { useState, useEffect } from 'react';
import { Container, Grid, Card, Title, Text, Button, Table, ActionIcon, Loader } from '@mantine/core';
import { FaEdit, FaTrash, FaEye, FaPlus } from 'react-icons/fa';
import { makeGetRequest, makeDeleteRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { isErrorObject } from '../utils/utils';
import { useNavigate } from 'react-router-dom';
import { BlogCategory, BlogPost } from '../types';
import { Link } from 'react-router-dom';


const BlogPostManager: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [categories, setCategories] = useState<BlogCategory[]>([]);
  

  const navigate = useNavigate();

  const createPost =()=>{
    navigate('/blog-admin-dashboard/post/new');
  }

  const fetchPosts = async () => {
    setIsLoading(true);
    const res = await makeGetRequest('blog-posts-admin');
    if (isErrorObject(res)) {
      setIsLoading(false);
      setError(ErrorHandler(res));
    } else {
      setPosts(res.data);
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {
    const res = await makeGetRequest('blog-post-categories');      
    if (isErrorObject(res)) {
      const errorMessage = ErrorHandler(res);
      setError(errorMessage);
      console.log(error)
  } else {
    setCategories(res.data);
      setError(null);
  }


   
  };

  const handleDelete = async (postId: string) => {
    const res = await makeDeleteRequest(`blog-post/${postId}`);
    if (!isErrorObject(res)) {
      setPosts(posts.filter(post => post.id !== postId));
    } else {
      setError(ErrorHandler(res));
    }
  };

  useEffect(() => {
    fetchPosts();
    fetchCategories();
  }, []);

  return (
    <Container>
      <Title order={2}>Blog Dashboard</Title>
      {error && <Text color="red">{error}</Text>}
      {isLoading ? <Loader /> : (
        <>
          <Grid>
            <Grid.Col span={3}><Card shadow="sm" padding="lg"><Text>Total Posts: {posts.length}</Text></Card></Grid.Col>
            <Grid.Col span={3}><Card shadow="sm" padding="lg"><Text>Total Categories: {categories.length}</Text></Card></Grid.Col>
           {/* <Grid.Col span={3}><Card shadow="sm" padding="lg"><Text>Total Likes: {posts.reduce((acc, post) => acc + post.likes.length, 0)}</Text></Card></Grid.Col>
            <Grid.Col span={3}><Card shadow="sm" padding="lg"><Text>Total Claps: {posts.reduce((acc, post) => acc + post.claps, 0)}</Text></Card></Grid.Col>*/}
          </Grid>
          <Button leftIcon={<FaPlus />} style={{ margin: '20px 0' }} onClick={()=>createPost()}>New Post</Button>
          <Table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Views</th>
                <th>Likes</th>
                <th>Claps</th>
                <th>Comments</th>
                <th>Shares</th>
                <th>Published</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {posts.map((post) => (
                <tr key={post.id}>
                  <td><Link to={`/blog/post/${post.slug}/${post.id}`}>{post.title}</Link></td>
                  <td>{post.category.category}</td>
                  <td>{post.views}</td>
                  <td>{post.likes.length}</td>
                  <td>{post.claps}</td>
                  <td>{post.comments.length}</td>
                  <td>{post.shares}</td>
                  <td>{post.published ? 'Yes' : 'No'}</td>
                  <td>
                    <ActionIcon color="blue" component="a" href={`/blog-admin-dashboard/post/${post.id}/edit`}><FaEdit /></ActionIcon>
                    <ActionIcon color="red" onClick={() => handleDelete(post.id)}><FaTrash /></ActionIcon>
                    <ActionIcon color="green" component="a" href={`/blog/post/${post.slug}/${post.id}`}><FaEye /></ActionIcon>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  );
};

export default BlogPostManager;